import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import handleRequest from '../utils/handle-request';

async function fetchList(uri, params, currentPage, cancelToken) {
  const method = 'get';
  const data = { ...params, page: currentPage + 1 };
  const config = { cancelToken };
  return handleRequest(method, uri, data, config);
}

function getList(uri, parameters) {
  const [data, setData] = useState([]);
  const [from, setFrom] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [params, setParams] = useState(parameters);

  const reload = useCallback(() => {
    const { CancelToken } = axios;
    const { token, cancel } = CancelToken.source();
    const fetch = async () => {
      setIsLoading(true);
      // const response = await fetchList(uri, params, currentPage, perPage, token);
      const response = await fetchList(uri, params, currentPage, token);
      if (response.success) {
        setData(response.data.records);
        setTotalItems(5);
        setIsLoading(false);
      }
    };

    fetch();

    return () => cancel('component unmount');
  }, [currentPage, params]);

  useEffect(() => {
    const { CancelToken } = axios;
    const { token, cancel } = CancelToken.source();
    const fetch = async () => {
      setIsLoading(true);
      const response = await fetchList(uri, params, currentPage, token);
      if (response.success) {
        // setFrom(response.data.from);
        setData(response.data.records);
        setTotalItems(response.data.total_records);
        setPerPage(response.data.records_per_page);
        setIsLoading(false);
      }
    };

    fetch();

    return () => cancel('component unmount');
  }, [currentPage, params]);

  const changePage = (e, page) => setCurrentPage(page);

  const changeParams = (parms) => {
    setCurrentPage(0);
    setParams(parms);
  };

  const refreshSingleRow = useCallback(async (documentNumber) => {
    const { CancelToken } = axios;
    const { token, cancel } = CancelToken.source();
    try {
      const response = await fetchList(uri, { ...params, document_number: documentNumber }, 0, token);
      if (response.success && response.data.records.length > 0) {
        setData(prevData => prevData.map(row => 
          row.document_number === documentNumber ? response.data.records[0] : row
        ));
      }
    } catch (error) {
      console.error('Error refreshing row:', error);
    }
  }, [uri, params]);

  return {
    data,
    currentPage,
    totalItems,
    perPage,
    isLoading,
    changePage,
    setPerPage,
    reload,
    from,
    params,
    changeParams,
    refreshSingleRow,
  };
}

export default getList;
